import React from "react";
import { useFcardGroup } from "./hooks/useFcardPaymentMethod";
import styles from "./style/FcardPaymentMethod.module.scss";
/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FcardPaymentMethod = ({ arrayGroups = [] , action=()=>{}, actionParams={} }) => {
  return (
    <div>
      <ul
        role="list"
        className="mt-3 grid grid-cols-1 flex-col gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-2 "
      >
        {arrayGroups.map((group) => (
          <li
            key={group.name}
            className="col-span-1 flex shadow-md rounded-xl border-2 cursor-pointer"
            onClick={() => {
              action(group.id, actionParams.amount, actionParams.originCurrency, actionParams.destinationCurrencyId, '', actionParams.idFiadoFlash, actionParams.exchangeRateId, actionParams.component)
            }}
          >
            <div
              className={classNames(
                "flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md border-b-1 p-4"
              )}
            >
              <img
                src={require("../../components/assets/images/credit-card2.png")}
                className="w-6"
                alt=""
              />
            </div>
            <div className="flex-1 flex items-center justify-between border-gray-200 bg-white rounded-r-md truncate">
              <div className="flex-1 px-4 py-2 text-sm truncate">
                <a className="text-gray-900 font-medium hover:text-gray-600">
                  {group.name}
                </a>
                <p className="text-gray-500">{group.displayName}</p>
              </div>
              <div className="flex-shrink-0 pr-2">
                <button
                  type="button"
                  className="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <span className="sr-only">Open options</span>
                  <ChevronRightIcon className="w-5 h-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FcardPaymentMethod;
